import { primeIcon } from "../../icon";
import { CLEAR_FILTERS_LABEL, UNDO_CLEAR_LABEL } from "../messages";
import type { FilterPanelViewModel } from "../types-filter-panel";

const UNDO_ICON = primeIcon("undo", 14);

/** "Limpar Filtros" ou, nos 5 s depois de Limpar, "Desfazer": o mesmo botão no rodapé (desktop) e no grupo (mobile). */
export function resolveClearButton(panel: FilterPanelViewModel) {
  return panel.canUndo
    ? {
        className: panel.classNames.clearButton,
        icon: UNDO_ICON,
        label: UNDO_CLEAR_LABEL,
        disabled: false,
        onClick: panel.undo,
        testId: panel.partTestId("undo"),
      }
    : {
        className: panel.classNames.clearButton,
        icon: undefined,
        label: CLEAR_FILTERS_LABEL,
        disabled: !panel.canClear,
        onClick: panel.clear,
        testId: panel.partTestId("clear"),
      };
}
